const PhoneIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
<rect opacity="0.01" width="24" height="24" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.85 8.32279V3H5H3V3.9L3.00247 4.2C3.03862 6.39435 3.47084 8.49925 4.24228 10.4322C5.8097 14.6651 8.81396 17.8215 12.9897 19.5371C15.1191 20.476 17.5143 21 20.1 21H21V19V15.15H15.6772L13.3216 17.5041C10.1996 16.1056 7.88339 13.7689 6.49809 10.6745L8.85 8.32279Z" fill="black"/>
</svg>`;
export default PhoneIcon;
